import BlockDetail from "../../../../components/quality/punchlist/mapview/blockDetail";


const PunchlistBlockDetail = () => {
    return <BlockDetail />;
};

export default PunchlistBlockDetail;